import { z } from 'zod';
/**
 * Identifiant de connexion : on garantit seulement que c'est bien une chaîne
 * non vide. Volontairement **pas** de `.email()` — un compte existant dont
 * l'adresse ne passerait pas le format strict de zod doit continuer à pouvoir
 * se connecter. 320 = longueur maximale d'une adresse (64 + @ + 255).
 */
const loginEmail = () => z.string().min(1).max(320);
/**
 * Mot de passe : aucune règle de complexité ici (elle appartient au service et
 * aux comptes déjà créés), seule une borne haute évite d'envoyer un mégaoctet
 * à bcrypt.
 */
const passwordString = () => z.string().max(512);
/**
 * Corps de `POST /admin/auth/login`. Sans validation, un `email` non-string
 * faisait planter `loginDto.email.toLowerCase()` en 500 au lieu d'un 400.
 */
export const adminLoginWithEmailSchema = z.object({
    email: loginEmail(),
    password: passwordString(),
});
/**
 * Corps de `POST /auth/checkout-register`. La comparaison
 * `password`/`passwordConfirmation` reste dans le service : elle porte son
 * propre message d'erreur métier.
 */
export const checkoutRegisterSchema = z.object({
    email: loginEmail(),
    password: passwordString(),
    passwordConfirmation: passwordString(),
});
/**
 * Corps de `POST /auth/reservation-access`. Les deux champs de mot de passe
 * restent optionnels : le front ne les envoie qu'au second tour, quand le
 * serveur a répondu `PASSWORD_REQUIRED`.
 */
export const reservationAccessSchema = z.object({
    email: loginEmail(),
    lastName: z.string().min(1).max(200),
    password: passwordString().optional(),
    passwordConfirmation: passwordString().optional(),
    pnr: z.string().min(1).max(64),
});
